import React from "react";
import { Dropdown } from "react-bootstrap";
import close from "../../../images/close-icon.svg";
import notification from "../../../images/notification-icon.svg";
import { useSubscription, useMutation } from "@apollo/client";
import {
  GET_NOTIFICATION,
  GET_NOTIFICATION_COUNT,
} from "../../../subscription/getNotification";
import { hasuraWsClient, hasuraClient } from "../../../apolloClient";
import moment from "moment";
import { DELETE_NOTIFICATION } from "../../../mutation/deleteNoti";
import { Link } from "react-router-dom";
import { SET_SEEN_NOTIFICATION } from "../../../mutation/setSeenNoti";

const Notification = () => {
  const {
    data: notificationData,
    error: notiError,
    loading,
  } = useSubscription(GET_NOTIFICATION, {
    fetchPolicy: "network-only",
    client: hasuraWsClient,
  });

  const { data: notificationCount } = useSubscription(GET_NOTIFICATION_COUNT, {
    fetchPolicy: "network-only",
    client: hasuraWsClient,
  });

  const [deleteNotification] = useMutation(DELETE_NOTIFICATION, {
    client: hasuraClient,
  });

  const [setSeenNotification] = useMutation(SET_SEEN_NOTIFICATION, {
    client: hasuraClient,
  });

  let routeRedirect = {
    new_message: "/message-business",
    bussiness_review_new_created: "/business-profile/review",
    referral_program_new_created: "/referrals-details",
    terms_of_service_new_created: "/settings/terms_of_services",
    terms_of_service_updated: "/settings/terms_of_services",
  };

  function seenNoti(data) {
    setSeenNotification({
      variables: {
        notification_id: data.id,
        seen_at: moment().format(),
      },
    }).catch(() => {});
  }

  return (
    <Dropdown className="header-notification">
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className="header-notification"
      >
        <span className="icon">
          <img src={notification} alt="Notification" />
        </span>
        {notificationCount &&
        notificationCount?.unread_notifications_count?.aggregate?.count ? (
          <span className="notify-active">
            <span></span>
          </span>
        ) : (
          ""
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className="notification-title">
          <h3>Notifications</h3>
          {notificationCount &&
          notificationCount?.unread_notifications_count?.aggregate?.count ? (
            <div className="count">
              <p>
                {notificationCount?.unread_notifications_count?.aggregate
                  ?.count > 99
                  ? "99+"
                  : notificationCount?.unread_notifications_count?.aggregate
                      ?.count}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        {notificationData &&
        !loading &&
        !notiError &&
        notificationData.notification_logs.length ? (
          notificationData.notification_logs.map((data) => (
            <Dropdown.Item>
              <span className="h-notification-list-cover">
                <Link
                  to={
                    data?.sub_category && routeRedirect[data?.sub_category]
                      ? routeRedirect[data?.sub_category]
                      : "/dashboard"
                  }
                >
                  <span
                    className="cart-icon"
                    onClick={() => {
                      seenNoti(data);
                    }}
                  >
                    <img src={data?.notification_icon?.icon_url} alt="cart" />
                    {!data.seen_at ? (
                      <span className="cart-active">
                        <span></span>
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </Link>
                <Link
                  to={
                    data?.sub_category && routeRedirect[data?.sub_category]
                      ? routeRedirect[data?.sub_category]
                      : "/dashboard"
                  }
                >
                  <span
                    className="notification-label"
                    onClick={() => {
                      seenNoti(data);
                    }}
                  >
                    <span className="notification-subscrition">
                      {data.notification}
                    </span>
                    <span className="time">
                      {moment(data.created_at).startOf().fromNow()}
                    </span>
                  </span>
                </Link>
                <span
                  className="close"
                  onClick={() => {
                    deleteNotification({
                      variables: {
                        notification_id: data.id,
                      },
                    }).catch(() => {});
                  }}
                >
                  <img src={close} alt="close icon" />
                </span>
              </span>
            </Dropdown.Item>
          ))
        ) : notiError ? (
          <p className="text-paragraph">some error occurred...</p>
        ) : (
          <p className="text-paragraph">You are up to date...</p>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default Notification;
